"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdLanguageToJSON = exports.AdLanguageFromJSONTyped = exports.AdLanguageFromJSON = exports.AdLanguage = void 0;
/**
 * The language which the ad is presented.
 * @export
 */
exports.AdLanguage = {
    English: 'ENGLISH',
    French: 'FRENCH',
    German: 'GERMAN',
    Italian: 'ITALIAN',
    Portuguese: 'PORTUGUESE',
    Spanish: 'SPANISH',
    Danish: 'DANISH',
    Dutch: 'DUTCH',
    Finnish: 'FINNISH',
    Norwegian: 'NORWEGIAN',
    Swedish: 'SWEDISH',
    Japanese: 'JAPANESE'
};
function AdLanguageFromJSON(json) {
    return AdLanguageFromJSONTyped(json, false);
}
exports.AdLanguageFromJSON = AdLanguageFromJSON;
function AdLanguageFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdLanguageFromJSONTyped = AdLanguageFromJSONTyped;
function AdLanguageToJSON(value) {
    return value;
}
exports.AdLanguageToJSON = AdLanguageToJSON;
